import styled from "styled-components";
import FieldsGroup from "../../../../../../shared/fieldsGroup/fieldsGroup.styles";
import { OutlinedButton } from "../../../../../../shared/native/button.styles";

export const ActionsRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const FilesActionsGroup = styled(FieldsGroup)`
  width: auto;
  flex: 0 1 auto;
`;

export const OnlinePaymentButton = styled(OutlinedButton)`
  flex-shrink: 0;
  white-space: nowrap;
`;
